/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./input.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./input.component";
var styles_InputComponent = [i0.styles];
var RenderType_InputComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_InputComponent, data: {} });
export { RenderType_InputComponent as RenderType_InputComponent };
export function View_InputComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_InputComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "input", [["ccInput", ""]], null, null, null, View_InputComponent_0, RenderType_InputComponent)), i1.ɵdid(1, 114688, null, 0, i2.InputComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var InputComponentNgFactory = i1.ɵccf("input[ccInput]", i2.InputComponent, View_InputComponent_Host_0, {}, {}, []);
export { InputComponentNgFactory as InputComponentNgFactory };
